import styled from '@emotion/styled';
import { Colors } from '../palettes/colorPalette';
import { backgroundTexture } from '../uiConstants';

export const Tooltip = styled.div`
	background: url(${backgroundTexture});
	color: ${Colors.UIDescriptionText};
	width: 19em;
	background-color: ${Colors.UIBackground};
	text-shadow: none;
	text-align: center;
	border-radius: 10pt;
	filter: drop-shadow(2px 4px 2px ${Colors.UITextAndBorders});
	margin: 1em;
	padding-left: 2em;
	padding-right: 2em;
	padding-bottom: 1em;
	font-size: 1vw;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;
